import { AxiosResponse } from "axios";
import { MERCHANT_V3_API_URLS as M3_API } from "@/apps/merchant3/services/apiClient/apiUrl";
import { jwtApiClient } from "@/apps/merchant3/services/apiClient/apiClient";

export const acceptTerms = async (
  cartTag: string
): Promise<AxiosResponse<unknown>> => {
  return await jwtApiClient.put(
    M3_API().ACCEPT_TERMS,
    {},
    {
      params: { cartTag },
      headers: {
        Prefer: "code=200, example=default",
      },
    }
  );
};

/**
 * To get the Terms and conditions document HTML
 * @param locale string
 * @param cartTag string (optional) - used for Brazil subscription model detection
 * @param version string
 * @returns document HTML
 */
export const getTermsAndConditions = async (
  locale: string,
  cartTag?: string,
  version?: string
): Promise<AxiosResponse<unknown>> => {
  return await jwtApiClient.get(M3_API().TERMS_AND_CONDITIONS, {
    params: {
      locale,
      ...(cartTag && { cartTag }),
      ...(version && { version }),
    },
    headers: {
      Prefer: "code=200, example=Get Terms Document",
    },
  });
};
